module.exports = __webpack_public_path__ + "static/media/4.LOMBARDINI.f5421a77.jpg";